import React from 'react';
import { parseCropHash, getFramedImageStyles } from 'utils/cropUtils';
import { Anchor, ListItem, ListItemInformation } from './styles';

interface Props {
  img: string;
  category: string;
  dateStr: string;
  eventName: string;
  slug: string;
}

const ScheduleCard: React.FC<Props> = (props: Props) => {
  const { img, category, dateStr, eventName, slug } = props;
  const { cleanUrl, crop } = parseCropHash(img);
  const { containerStyle, imageStyle } = getFramedImageStyles(crop);

  return (
    <Anchor className="event-box" href={'/events/' + slug} rel="noreferrer">
      <ListItem>
        <div
          className="list-item-image"
          style={{
            position: 'relative',
            overflow: 'hidden',
          }}>
          <div
            style={{
              position: 'absolute',
              top: '-10%',
              left: '-10%',
              width: '120%',
              height: '120%',
              background: `url(${cleanUrl}) center center / cover no-repeat`,
              filter: 'blur(15px)',
              zIndex: 1,
            }}
          />
          <div style={containerStyle}>
            <img src={cleanUrl} alt={eventName} style={imageStyle} />
          </div>
        </div>
        <ListItemInformation>
          <span>{category}</span>
          <time>{dateStr}</time>
          <h1>{eventName}</h1>
        </ListItemInformation>
      </ListItem>
    </Anchor>
  );
};

export default ScheduleCard;
